import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { timelineData, timelineFilters } from "@/mocks/homeData";

const phaseStyles: Record<string, string> = {
  起点: "bg-secondary-100 text-secondary-900",
  发酵: "bg-primary-100 text-primary-700",
  爆发: "bg-accent-100 text-accent-800",
  后续: "bg-background-200 text-foreground-800",
};

export default function TimelineSection() {
  const [active, setActive] = useState("全部");

  const items = active === "全部" ? timelineData : timelineData.filter((item) => item.phase === active);

  return (
    <section id="timeline" className="w-full border-y border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <Reveal className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="font-label text-xs tracking-[0.2em] text-accent-700">TIMELINE</span>
            <h3 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              超碰吃瓜时间线 · 来龙去脉
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              每个节点都保留发生时间、阶段与信源标注。先看阶段，再挑节点，顺序读下来就是完整的前因后果。
            </p>
          </div>

          <div className="flex flex-wrap gap-2 rounded-full border border-background-200/80 bg-background-50 p-1">
            {timelineFilters.map((filter) => (
              <button
                key={filter}
                type="button"
                onClick={() => setActive(filter)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  active === filter
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        </Reveal>

        <ol className="relative mt-12 space-y-6 md:space-y-8">
          <span className="absolute left-[7px] top-2 hidden h-[calc(100%-1rem)] w-px bg-background-300 md:block"></span>
          {items.map((item, index) => (
            <li key={item.id} className="relative md:pl-12">
              <span className="absolute left-0 top-6 hidden h-4 w-4 items-center justify-center md:flex">
                <span className="h-4 w-4 rounded-full border-4 border-background-100 bg-accent-500"></span>
              </span>

              <Reveal delay={index * 60}>
                <article className="rounded-lg border border-background-200/80 bg-background-50 p-5 transition-transform hover:-translate-y-0.5 md:p-6">
                  <div className="flex flex-wrap items-center gap-3">
                    <span className={`rounded-full px-3 py-1 text-xs font-medium ${phaseStyles[item.phase] ?? phaseStyles["后续"]}`}>
                      {item.phase}
                    </span>
                    <span className="font-label text-sm tracking-wide text-foreground-500">
                      {item.date} · {item.time}
                    </span>
                    <span
                      className={`ml-auto inline-flex items-center gap-1 text-xs ${
                        item.verified ? "text-accent-700" : "text-foreground-500"
                      }`}
                    >
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className={item.verified ? "ri-checkbox-circle-line text-sm" : "ri-question-line text-sm"}></i>
                      </span>
                      {item.verified ? "已核实" : "存疑待证"}
                    </span>
                  </div>

                  <h4 className="mt-4 font-heading text-lg font-bold text-foreground-950">{item.title}</h4>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.desc}</p>

                  <div className="mt-4 flex flex-wrap gap-2">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-md bg-background-100 px-2.5 py-1 text-xs text-foreground-600"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>
                </article>
              </Reveal>
            </li>
          ))}
        </ol>

        {items.length === 0 && (
          <p className="mt-12 rounded-lg border border-dashed border-background-300 bg-background-50 p-8 text-center text-sm text-foreground-500">
            该阶段暂时没有节点，换个阶段看看。
          </p>
        )}
      </div>
    </section>
  );
}